import { render } from "./AustraliaHub.vue?vue&type=template&id=155d3322"
import script from "./AustraliaHub.vue?vue&type=script&lang=js"
export * from "./AustraliaHub.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__